<template>
    <div>
        <nav-bar :key="1"></nav-bar>
        <div class="content">
            <nav-left-bar :active="1" :key="1"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <img src="../assets/icon/bg.png" alt="" />
                    <div class="tc">修改密码</div>
                </div>
                <div class="changePwd">
                    <div style="height:35px;"></div>
                    <div class="li">
                        <label>原密码：</label>
                        <input
                            type="password"
                            placeholder="请输入原密码"
                            v-model="oldPassword"
                        />
                    </div>
                    <div class="li">
                        <label>新密码：</label>
                        <input
                            type="password"
                            placeholder="请输入新密码"
                            v-model="newsPassword"
                        />
                    </div>
                    <div class="li">
                        <label>确认密码：</label>
                        <input
                            type="password"
                            placeholder="再次输入新密码"
                            v-model="truePassword"
                        />
                    </div>
                    <div class="btn" @click="apply">确认修改</div>
                </div>
            </div>
        </div>
        <van-dialog
            v-model="close"
            style="width:430px;height"
            title="修改密码"
            showCancelButton
            @confirm="confirm"
        >
            <div class="tr">确认要修改密码吗?</div>
        </van-dialog>
    </div>
</template>
<script>
export default {
    name: "changePassword",
    data() {
        return {
            oldPassword: "",
            newsPassword: "",
            truePassword: "",
            close: false
        };
    },
    methods: {
        apply() {
            if (this.oldPassword == "") {
                this.$toast("旧密码不能为空");
                return;
            }
            if (this.newsPassword == "") {
                this.$toast("新密码不能为空");
                return;
            }
            if (this.truePassword == "") {
                this.$toast("确认密码不能为空");
                return;
            }
            this.close = true;
        },
        confirm() {
            let params = {
                old_password: this.oldPassword,
                password: this.newsPassword,
                password_confirm: this.truePassword
            };
            this.$post("/api/person/update_password", params)
                .then(res => {
                    this.$toast(res.msg);
                    if (res.code == 1) {
                        localStorage.removeItem("username");
                        localStorage.removeItem("token");
                        setTimeout(() => {
                            this.$router.replace("/login");
                        }, 1500);
                    }
                })
                .catch(err => {});
        }
    }
};
</script>
<style lang="less" scoped>
.tr {
    padding: 50px 0;
}
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            display: flex;
            align-items: center;
            img {
                width: 5px;
                height: 24px;
            }
            .tc {
                font-size: 24px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                padding-left: 13px;
            }
        }
        .changePwd {
            width: 838px;
            height: 513px;
            background: #ffffff;
            margin-top: 21px;
            .li {
                display: flex;
                height: 40px;
                align-items: center;
                margin-bottom: 15px;
                padding-left: 18px;
                label {
                    width: 77px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    color: #333333;
                    letter-spacing: 0px;
                }
                input {
                    width: 230px;
                    height: 40px;
                    line-height: 40px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    padding-left: 10px;
                    margin-left: 16px;
                    font-size: 14px;
                    color: #333333;
                    &::placeholder {
                        font-size: 14px;
                        font-family: PingFangSC, PingFangSC-Regular;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
            .btn {
                width: 346px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                background: #3449d3;
                border-radius: 5px;
                color: #ffffff;
                font-size: 16px;
                margin: 0 auto;
                margin-top: 255px;
                cursor: pointer;
            }
        }
    }
}
</style>
